import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { AddressMethod } from "src/components/shared-components/interfaces/address-method";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";

@Component({
    selector: "app-popup-content-address-methods",
    templateUrl: "./popup-content-address-methods.component.html",
    styleUrls: ["./popup-content-address-methods.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupContentAddressMethodsComponent implements OnInit, OnDestroy, iEvent {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() listMethods: Array<AddressMethod>;

  public _eventSubscriptions: Array<Subscription> = null;

  constructor(
    private _modalController: ModalController,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Close button: dismisses without data, the same result as a tap on the backdrop
   */
  public onClickClose(): void {
    this._modalController.dismiss();
  }

  /**
   * Handle click method click execution
   *
   * @param selectedValue Cliecked value
   */
  public onClickExecuteMethods(selectedValue: string): void {
    this._modalController.dismiss(selectedValue);
  }
}
